module.exports = __webpack_public_path__ + "static/WFM_pin-ba39cb76a2ae541ea41fd818e7e04c5f.png";